<template>
  <div>
    <el-row id="loadingBoxBank">
      <el-form
        :inline="true"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
      >
        <el-form-item label="开户银行类别:" prop="bankName">
          <el-select
            v-model="ruleForm.bankName"
            filterable
            placeholder="请填写开户银行类别"
          >
            <el-option
              v-for="(item, index) in banks"
              :key="index"
              :label="item.colValue"
              :value="item.colValue"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="银行所在区域:" prop="bankTownCodeList">
          <el-cascader
            v-model="ruleForm.bankTownCodeList"
            :options="options"
            :props="props"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="开户银行名称:" prop="bankAddress">
          <el-input
            v-model="ruleForm.bankAddress"
            maxlength="50"
            placeholder="请填写开户银行名称"
          ></el-input>
        </el-form-item>

        <!-- prop="unionLineNumber" -->
        <el-form-item label="开户行联行号:" class="position_box">
          <el-input
            v-model="ruleForm.unionLineNumber"
            placeholder="请填写联行号"
          ></el-input>
          <a href="http://www.icvio.cn" target="_blank"
            >（查询网址：http://www.icvio.cn）</a
          >
        </el-form-item>

        <el-form-item label="企业结算名称:" prop="balanceName">
          <el-input
            v-model="ruleForm.balanceName"
            :disabled="ruleForm.balanceName ? true : false"
            placeholder="请填写企业结算名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="银行账号:" prop="bankAccount">
          <el-input
            :disabled="editId ? true : false"
            v-model="ruleForm.bankAccount"
            maxlength="50"
            placeholder="请填写银行账号"
          ></el-input>
        </el-form-item>

        <el-form-item label="账号类别:" prop="accountAttribute">
          <el-select v-model="ruleForm.accountAttribute" placeholder="请选择">
            <el-option
              v-for="(item, index) in AttributeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="收付款户标记:" prop="payerTag">
          <el-select v-model="ruleForm.payerTag" placeholder="请选择">
            <el-option
              v-for="(item, index) in stateList"
              :label="item.label"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="结算币种:" prop="currencyCode">
          <el-select v-model="ruleForm.currencyCode" placeholder="请选择">
            <el-option
              v-for="(item, index) in CurrencyTypeList"
              :label="item.colValue"
              :value="item.colKey"
              :key="index"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="是否接受电子承兑" prop="electronicBill">
          <el-radio-group
            v-model="ruleForm.electronicBill"
            @change="getElectronicBill"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="是否接收新票"
          prop="isReceiveNew"
          v-if="ruleForm.electronicBill == '1'"
        >
          <el-radio-group v-model="ruleForm.isReceiveNew">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          class="bankAttach_Pic"
          label="开户许可证上传（或其他相关银行账号加盖印章的说明）:"
          label-width="100%"
          prop="bankAttach"
        >
          <el-input
            style="display: none"
            v-model="ruleForm.bankAttach"
          ></el-input>
          <el-upload
            :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
            action="actionUpload"
            ref="upload"
            :http-request="addBankData"
            :limit="1"
            :on-change="dealImgChange"
            list-type="picture-card"
            :file-list="companyUploadList"
            :auto-upload="false"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }" style="height: 100%">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <!--									<span-->
                <!--                      class="el-upload-list__item-preview"-->
                <!--                      @click="handlePictureCardPreview(file)">-->
                <!--										<i class="el-icon-zoom-in"></i>-->
                <!--									</span>-->
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleDealImgRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <!--            <el-dialog :visible.sync="dialogVisible">-->
          <!--              <img width="100%" :src="dialogImageUrl" alt="" />-->
          <!--            </el-dialog>-->
          <div class="el-upload__tip">
            只能上传jpg/png/jpeg文件，且不超过1Mb
          </div>
        </el-form-item>

        <el-col :span="24" style="text-align: center">
          <el-form-item label-width="0px">
            <el-button
              type="primary"
              :loading="submitBtn"
              @click="addBank('ruleForm')"
              >提交</el-button
            >
            <!--            <el-button @click="addBankQuit">返回</el-button>-->
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import { base } from "@/api/base"; // 导入接口域名列表
import fileToBase64 from "@/utils/file";

export default {
  props: {
    //判断是否登录
    demoBoolean: {
      type: Boolean,
      default: true,
    },
    editId: {
      type: String,
    },
  },
  data() {
    return {
      submitBtn: false,
      banks: [], //所有银行
      ruleForm: {
        bankAttach: "",
        isReceiveNew: "",
      },
      rules: {
        bankName: [
          {
            required: true,
            message: "请填写正确的开户银行类别",
            trigger: "blur",
          },
        ],
        bankTownCodeList: [
          { required: true, message: "请选择银行所在区域", trigger: "change" },
        ],
        bankAddress: [
          { required: true, message: "请填写开户银行名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "请填写正确的开户银行名称格式",
            trigger: "blur",
          },
        ],
        unionLineNumber: [
          { required: true, message: "请填写联行号", trigger: "blur" },
        ],
        balanceName: [
          { required: true, message: "请填写企业结算名称", trigger: "blur" },
        ],
        bankAccount: [
          { required: true, message: "请填写银行账号", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "银行账号格式（长度19）",
            trigger: "blur",
          },
        ],
        accountAttribute: [
          { required: true, message: "请选择账号类别", trigger: "change" },
        ],
        payerTag: [
          { required: true, message: "请选择收付款户标记", trigger: "change" },
        ],
        currencyCode: [
          { required: true, message: "请选择结算币种", trigger: "change" },
        ],
        electronicBill: [
          { required: true, message: "是否接受电子承兑", trigger: "blur" },
        ],
        isReceiveNew: [
          { required: true, message: "是否接收新票", trigger: "blur" },
        ],
        bankAttach: [
          { required: true, message: "请上传开户许可证", trigger: "change" },
        ],
        bankType: [{ required: true, message: "银行全称", trigger: "blur" }],
      },
      fileBase64Url: "",
      // 文件上传
      showBtnDealImg: true,
      noneBtnImg: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      companyUploadList: [],
      fileList: [],
      // 账户类别
      AttributeList: [
        {
          label: "一般结算账户",
          value: "00",
        },
        {
          label: "融资账户",
          value: "01",
        },
        {
          label: "其他",
          value: "02",
        },
      ],
      // 收付款标记
      stateList: [
        {
          label: "收款户",
          value: "0",
        },
        {
          label: "付款户",
          value: "1",
        },
        {
          label: "收付款户",
          value: "2",
        },
      ],
      //币种
      CurrencyTypeList: [],
      //城市
      options: [],
      props: {
        value: "areaCode",
        label: "areaName",
        children: "childAreaInfo",
      },
      gcode: "",
    };
  },
  methods: {
    getElectronicBill() {
      this.ruleForm.isReceiveNew = "";
    },
    //币种
    getCurrency() {
      this.$api.supplier.getCurrencyTypeList().then((res) => {
        this.CurrencyTypeList = res.data;
        // console.log(this.CurrencyTypeList)
      });
    },
    //返回
    addBankQuit() {
      this.$router.go(-1);
    },
    //提交
    addBank() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.editId) {
            // console.log(this.$refs.upload.uploadFiles[0]);
            if (this.$refs.upload.uploadFiles[0].raw) {
              // console.log(1111);
              this.$refs.upload.submit();
            } else {
              // console.log(333);
              this.addBankDataOne();
            }
          } else {
            this.$refs.upload.submit();
          }
        } else {
          this.$message.warning("请完善必填信息!");
          return false;
        }
      });
    },
    //附件删除
    handleDealImgRemove(file) {
      this.companyUploadList = [];
      this.noneBtnImg = false;
      this.ruleForm.bankAttach = "";
    },
    // 附件查看
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    dealImgChange(file, fileList) {
      let types = ["image/jpeg", "image/png"];
      const isJPG = types.includes(file.raw.type);
      const isLt2M = file.raw.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传文件只能是 JPG/PNG/JPEG 格式!");
        this.companyUploadList = [];
      } else {
        if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 1MB!");
          this.companyUploadList = [];
        } else {
          this.companyUploadList = fileList;
          this.noneBtnImg = fileList.length >= 1;
          this.ruleForm.bankAttach = "55555";
        }
      }
    },
    async addBankData(parent) {
      //  console.log(this.banks);
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          let bankType = "";
          this.banks.forEach((item) => {
            if (item.colValue == this.ruleForm.bankName) {
              bankType = item.colKey;
            }
          });
          let currencyName = this.CurrencyTypeList.filter(
            (ele) => ele.colKey == this.ruleForm.currencyCode
          )[0].colValue;
          this.submitBtn = true;
          let formData = new FormData();
          formData.append("sign", "1"); //标识数据来源为客商平台
          formData.append("bankName", this.ruleForm.bankName);
          if (this.editId) {
            formData.append("id", this.editId);
            formData.append("bankCheckStatus", this.ruleForm.bankCheckStatus);
          }
          formData.append(
            "companyCode",
            JSON.parse(localStorage.getItem("companyInfo")).bspCompanyCode || ""
          );
          formData.append("supplierCode", this.gcode);
          formData.append(
            "bankProvinceCode",
            this.ruleForm.bankTownCodeList[0]
          ); //省份代码
          formData.append("bankCityCode", this.ruleForm.bankTownCodeList[1]); //城市代码
          formData.append("bankTownCode", this.ruleForm.bankTownCodeList[2]); //地区代码
          formData.append("bankAddress", this.ruleForm.bankAddress);
          formData.append("unionLineNumber", this.ruleForm.unionLineNumber);
          formData.append("balanceName", this.ruleForm.balanceName);
          formData.append("bankAccount", this.ruleForm.bankAccount);
          formData.append("accountAttribute", this.ruleForm.accountAttribute);
          formData.append("payerTag", this.ruleForm.payerTag);
          formData.append("currencyCode", this.ruleForm.currencyCode);
          formData.append("currencyName", currencyName);
          formData.append("electronicBill", this.ruleForm.electronicBill);
          formData.append(
            "isReceiveNew",
            this.ruleForm.isReceiveNew == null ? "" : this.ruleForm.isReceiveNew
          );
          formData.append("bankType", bankType);
          formData.append("bankTypeValue", this.ruleForm.bankName);
          // const base64String = await fileToBase64(parent.file);
          // console.log(base64String); // 这里会打印出正确的 Base64 字符串
          formData.append("bankAttach", parent.file);
          let axios = "";
          if (this.demoBoolean) {
            axios = this.$api.supplier.bankSaveBankInfo(formData);
          } else {
            axios = this.$api.supplier.bankSaveBankInfoToken(formData);
          }

          this.$nextTick(() => {
            axios
              .then((res) => {
                this.submitBtn = false;
                // console.log(res);
                if (res.success) {
                  this.$message.success(res.msg);
                  this.$emit("bankDialogVisible", false);
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.submitBtn = false;
              });
          });
        } else {
          this.$message.warning("请完善必填信息!");
          return false;
        }
      });
    },
    addBankDataOne() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let bankType = "";
          this.banks.forEach((item) => {
            if (item.colValue == this.ruleForm.bankName) {
              bankType = item.colKey;
            }
          });
          let currencyName = this.CurrencyTypeList.filter(
            (ele) => ele.colKey == this.ruleForm.currencyCode
          )[0].colValue;
          this.submitBtn = true;
          let formData = new FormData();
          formData.append("sign", "1"); //标识数据来源为客商平台
          if (this.editId) {
            formData.append("id", this.editId);
            formData.append("bankCheckStatus", this.ruleForm.bankCheckStatus);
          }
          formData.append("bankName", this.ruleForm.bankName);
          formData.append(
            "companyCode",
            JSON.parse(localStorage.getItem("companyInfo")).bspCompanyCode || ""
          );
          // formData.append("bankTownCode", this.ruleForm.bankTownCode);
          formData.append(
            "bankProvinceCode",
            this.ruleForm.bankTownCodeList[0]
          ); //省份代码
          formData.append("supplierCode", this.gcode);
          formData.append("bankCityCode", this.ruleForm.bankTownCodeList[1]); //城市代码
          formData.append("bankTownCode", this.ruleForm.bankTownCodeList[2]); //地区代码
          formData.append("bankAddress", this.ruleForm.bankAddress);
          formData.append("unionLineNumber", this.ruleForm.unionLineNumber);
          formData.append("balanceName", this.ruleForm.balanceName);
          formData.append("bankAccount", this.ruleForm.bankAccount);
          formData.append("accountAttribute", this.ruleForm.accountAttribute);
          formData.append("payerTag", this.ruleForm.payerTag);
          formData.append("currencyCode", this.ruleForm.currencyCode);
          formData.append("currencyName", currencyName);
          formData.append("electronicBill", this.ruleForm.electronicBill);
          formData.append(
            "isReceiveNew",
            this.ruleForm.isReceiveNew == null ? "" : this.ruleForm.isReceiveNew
          );
          formData.append("bankType", bankType);
          formData.append("bankTypeValue", this.ruleForm.bankName);
          let axios = "";
          if (this.demoBoolean) {
            axios = this.$api.supplier.bankSaveBankInfo(formData);
          } else {
            axios = this.$api.supplier.bankSaveBankInfoToken(formData);
          }
          this.$nextTick(() => {
            axios
              .then((res) => {
                this.submitBtn = false;
                if (res.success) {
                  this.$message.success(res.msg);
                  this.$emit("bankDialogVisible", false);
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.submitBtn = false;
              });
          });
        } else {
          this.$message.warning("请完善必填信息!");
          return false;
        }
      });
    },
  },
  created() {
    // console.log(this.editId);
    this.getCurrency();
    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    if (companyInfo.gCode) this.gcode = companyInfo.gCode;
    // this.$api.client.getQueryCompanyByCode(JSON.parse(localStorage.getItem("companyInfo")).orgId).then(res=>{
    //   if( res.data.gCode) this.gcode = res.data.gCode;
    // })
    this.$api.supplier.postResumeBankTypeList().then((res) => {
      // console.log(res);
      this.banks = res.data;
    });
    //地址
    this.$api.client.postResumegetAreaList().then((res) => {
      this.options = res.data;
      if (this.editId) {
        //数据加载时整个页面显示loading
        const loading = this.$loading({
          //lock的修改符--默认是false
          lock: true,
          //显示在加载图标下方的加载文案
          text: "Loading",
          //自定义加载图标类名(在elementUI 文档查找)
          spinner: "el-icon-loading",
          //(可以自己定义)遮罩层颜色
          background: "rgba(255, 255, 255, .7)",
          //loadin覆盖的dom元素节点(整个页面的话'#body' 表格的话'#table'等等 )
          target: document.querySelector("#loadingBoxBank"),
        });
        this.$api.supplier.bankListEdit(this.editId).then((resList) => {
          // console.log(resList,'aaaaaaaaaaaaa')
          loading.close();
          if (resList.data.certificateUrl) {
            this.companyUploadList.push({
              name: resList.data.certificateNewName,
              url: `${base()}/srm-api/resume/attach/show?attachUrl=${
                resList.data.certificateUrl
              }&type=inline`,
            });
            this.noneBtnImg = true;
            resList.data.bankAttach = "5555";
          } else {
            resList.data.bankAttach = "";
          }
          resList.data.bankTownCodeList = [
            resList.data.bankProvinceCode,
            resList.data.bankCityCode,
            resList.data.bankTownCode,
          ];
          this.ruleForm = resList.data;
        });
      }
    });
    this.ruleForm.balanceName = JSON.parse(localStorage.getItem("companyInfo"))
      .companyName
      ? JSON.parse(localStorage.getItem("companyInfo")).companyName
      : JSON.parse(localStorage.getItem("companyInfo")).fullName
      ? JSON.parse(localStorage.getItem("companyInfo")).fullName
      : "";
  },
};
</script>
<style scoped>
::v-deep .disUoloadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
.position_box {
  position: relative;
}
.position_box a {
  position: absolute;
  font-size: 12px;
  right: 0;
  line-height: 30px;
  height: 30px;
  text-align: right;
  display: block;
}
::v-deep .bankAttach_Pic .el-form-item__content {
  margin-left: 140px;
}
</style>
